import { Controller, CustomArgs, Menu, Toolbar } from '@tencent/workbench';
import { UniformFontFeature } from './uniform-font-feature';
import { INSERT_TEXT_MENU_CONFIGS, config } from './config';
import ua from '@tencent/docs-user-agent';
import { toolbarConfig } from '@framework/workbench/ui/quick-setting/font-handle-title/config';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
})
export class UniformFontController {
    public constructor(private readonly feature: UniformFontFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(toolbarConfig.id, 'onClick', { reportConfig: toolbarConfig })
    public onClick(@CustomArgs() args: { reportConfig?: any }) {
        const defaultFont = ua.isMac ? 'PingFang SC' : 'Microsoft YaHei';
        const fontFamilyInfo = {
            titleFontEa: defaultFont,
            titleFontLatin: defaultFont,
            contentFontEa: defaultFont,
            contentFontLatin: defaultFont,
        };
        this.feature.getAppService()
            .editableServiceLayer?.quickToolDialogManager.promise().then((quickToolDialogManager) => {
                quickToolDialogManager.showUniformFontDialog(undefined, undefined, undefined, fontFamilyInfo);
            });
        if (args?.reportConfig) {
            this.feature.twdReport(undefined, undefined, args.reportConfig);
        }
    }
}
